import { createUseStyles } from "react-jss";

const styles = createUseStyles({
    reportsPage: {
        
    }
});

export default styles;